<pp-button
  [ppWarning]="true"
  ppId="updateSitePlanBtn--delete"
  ppStyle="primary"
  ppSize="small"
  (ppAction)="showDeletePlanModal()"
>
  {{ 'remove' | ppTranslate }}
</pp-button>
